import styled from 'styled-components';
import { ThemeType } from '../../../../types/Theme';

const PagamentosContainer = styled.div<{theme: ThemeType, loading: boolean}>`
    border-radius: 6rem;
    position: relative;
    overflow: ${({loading}) => loading ? 'hidden' : 'visible'};
    padding: 2rem 5rem;
    min-height: ${({loading}) => loading ? '40rem' : 'auto'};
    .titulo{
        text-align: center;
        font-weight: bold;
        color: ${({theme}) => theme.colors.secondary};
        margin-bottom: 2rem;
    }
    .pagamentos{
        display: flex;
        padding-bottom: 5rem;
        flex-direction: column;
        gap: 2rem;
        align-items: stretch;
        justify-content: center;
        .pagamento{
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .label{
                font-weight: 500;
            }
        }
    }
    .texto{
        text-align: justify;
        margin-bottom: 3rem;
    }
    .aviso{
        text-align: center;
        color: ${({theme}) => theme.colors.tertiary};
        opacity: 0.7;
        margin-top: 2rem;
        font-size: 1.4rem;
    }
    .botoes{
        margin-top:5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cancelar{
            cursor: pointer;
        }
    }
`;

export {
    PagamentosContainer,
};
